<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="h-[60%] min-h-[10%] overflow-hidden"
    closeable
    position="bottom"
    round
    teleport="body"
  >
    <div class="grid grid-rows-[auto_auto_1fr] overflow-hidden h-full">
      <h2 class="text-center my-4 text-lg font-bold">
        {{ $t("game.base.selectCharacter") }}
      </h2>
      <VanTabs v-model:active="tabType" v-if="showTab">
        <VanTab :title="$t('game.roleTab.my')" />
        <VanTab :title="$t('game.roleTab.myGuarded')" />
        <VanTab :title="$t('game.roleTab.guardians')" />
      </VanTabs>
      <div class="overflow-auto h-full">
        <div v-for="item in activeList" class="flex gap-4 my-3 px-3">
          <div class="flex flex-col items-center">
            <UserAvatar
              :avatar-url="item?.mediaUrl"
              class="w-[100px] aspect-[3/4] mb-4"
            />
          </div>
          <div class="flex-1 flex flex-col">
            <div class="flex justify-between items-center mb-2">
              <div class="flex">
                <p class="mr-2">{{ item.name }}</p>
                <i
                  :class="[
                    'iconfont',
                    item.gender === 1 && 'icon-male text-[#5D9CEC]',
                    item.gender === 2 && 'icon-female text-[#EC4899]',
                  ]"
                ></i>
              </div>
              <button
                class="btn btn-xs px-6"
                @click="clickSelect(item as Mate)"
              >
                {{ t(`story.role.select`) }}
              </button>
            </div>
            <p class="text-xs">
              {{ item.bio }}
            </p>
          </div>
        </div>
        <div v-if="activeList.length === 0">
          <VanEmpty :description="$t('Message.noCharactersAvailable')" />
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { useAdmire } from "@/stores/admire";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  showTab: {
    type: Boolean,
    default: false,
  },
  selectedIds: {
    type: Array,
    default: () => [],
  },
  characterList: {
    type: Array,
  },
});

const emit = defineEmits(["update:show", "select"]);
const { t } = useI18n();
const mateStore = useMate();
const admireStore = useAdmire();
const tabType = ref(0);

const clickSelect = async (item: Mate) => {
  emit("select", item);
};

const activeList = computed(() => {
  if (props.characterList) {
    return props.characterList
      .filter((item: any) => !props.selectedIds.includes(item.id!))
      .map((item: any) => {
        if (item.role === 2) {
          item.name = t(`game.player`);
        }
        return { ...item.mate, ...item };
      });
  }
  let list: Mate[] = [];
  if (tabType.value === 0) list = mateStore.list;
  else if (tabType.value === 1)
    list = admireStore.admirer.list.map((item) => item.fan);
  else if (tabType.value === 2)
    list = admireStore.admiring.list.map((item) => item.mate);
  list = list.filter((item) => !props.selectedIds.includes(item.id!));
  return list;
});

watch(
  () => props.show,
  (newVal) => {
    if (newVal) {
      tabType.value = 0;
    }
  }
);

onMounted(() => {
  if (props.showTab) {
    admireStore.getAdmirerList();
    admireStore.getAdmiringList();
  }
});
</script>
